import React from 'react'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import LoginPage from '../pages/LoginPage'
import SubscriptionPage from '../pages/SubscriptionPage'
import HomePage from '../pages/HomePage'
import AllQuizes from '../pages/AllQuizes'
import QuizDetails from '../pages/QuizDetails'
import Leaderboard from '../pages/Leaderboard'
import Profile from '../pages/Profile'
import ContactUs from '../pages/ContactUs'
import Policy from '../pages/Policy'
import Language from '../pages/Language'
import EditProfile from '../pages/EditProfile'
import History from '../pages/History'
import FindingOpponent from '../pages/FindingOpponent'
import Game from '../pages/Game'
import GameOver from '../pages/GameOver'
import ErrorBoundary from '../pages/ErrorBoundary'
import OtpPage from '../pages/OtpPage'
import ReverseQuizGame from "../pages/ReverseQuizGame"
import ReverseQuizGameOver from "../pages/ReverseQuizGameOver"
import FindingOpponentReverseQuiz from "../pages/FindingOpponentReverseQuiz"
import ReverseQuizPage from "../pages/ReverseQuizPage";
import LowBalancePage from '../pages/LowBalancePage'
import Auth from '../components/Auth'
import SubscriptionProcessing from '../pages/SubscriptionProcessing'
import WordGameDetails from '../pages/WordGameDetails'
import WordGamePlay from '../pages/WordGamePlay'
import Layout from '../components/Layout'
import WordGameOver from '../pages/WordGameOver'
import XOGameDetails from '../pages/XOGameDetails'
import XOGamePlay from '../pages/XOGamePlay'
import XOGameOver from '../pages/XOGameOver'

const Routes = () => {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <Layout>
                <SubscriptionPage />
            </Layout>
            ,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/login",
            element: 
             <Layout>
                 <LoginPage />
             </Layout>
            ,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/low-balance",
            element: 
            <Layout>
                <LowBalancePage />
            </Layout>
            ,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/subscription-processing",
            element: 
            <Layout>
                <SubscriptionProcessing />
            </Layout>
            ,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/home",
            element: 
            <Layout>
            <Auth>
                <HomePage />
            </Auth>
            </Layout>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/all-quizes",
            element: 
            <Layout>
            <Auth>
                <AllQuizes />
            </Auth>
            </Layout>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/quiz-details",
            element:
            <Layout>
                <Auth>
                    <QuizDetails />
                </Auth>

            </Layout>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/leaderboard",
            element: 
            <Layout>
            <Auth>
                <Leaderboard />
            </Auth>

            </Layout>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/profile",
            element:
            <Layout>
                <Auth>
                    <Profile />
                </Auth>

            </Layout>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/contact-us",
            element: 
            <Layout>
                <ContactUs />

            </Layout>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/policy",
            element:
            <Layout>
                <Policy />

            </Layout>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/language",
            element: 
            <Layout>
                <Language />
            </Layout>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/edit-profile",
            element:
            <Layout>
                <Auth>
                    <EditProfile />
                </Auth>
            </Layout>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/history",
            element:
            <Layout>
                <Auth>
                    <History />
                </Auth>
            </Layout>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/finding-opponent",
            element:
            <Layout>
                <Auth>
                    <FindingOpponent />
                </Auth>
            </Layout>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/game",
            element:
            <Layout>
                <Auth>
                    <Game />
                </Auth>
            </Layout>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/game-over",
            element: 
            <Layout>
                <GameOver />
            </Layout>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/reverse-quiz",
            element:
            <Layout>
                <Auth>
                    <ReverseQuizPage />
                </Auth>
            </Layout>
            ,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/reverse-quiz/finding-opponent",
            element:
            <Layout>
                <Auth>
                    <FindingOpponentReverseQuiz />
                </Auth>
            </Layout>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/reverse-quiz/game",
            element:
            <Layout>
                <Auth>
                    <ReverseQuizGame />
                </Auth>
            </Layout>
            ,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/reverse-quiz/game-over",
            element:
            <Layout>
                <ReverseQuizGameOver />
            </Layout>
            ,
            errorElement: <ErrorBoundary />
        },
        {
            path:"/xo-game-details",
            element:<Layout> <XOGameDetails /> </Layout>,
            errorElement:<ErrorBoundary />
        },
        {
            path:"/xo-game",
            element:<XOGamePlay />,
            errorElement:<ErrorBoundary />

        },
        {
            path:"/xo-game-over",
            element:<Layout><XOGameOver /></Layout> ,
            errorElement:<ErrorBoundary />
        },
        {
            path: "/word-game-details",
            element: 
            <Layout>
                <WordGameDetails />
            </Layout>
            ,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/word-game",
            element: <WordGamePlay />,
            errorElement: <ErrorBoundary />
        },
        {
            path:"/word-game-over",
            element:
            <Layout>
                <WordGameOver />
            </Layout>
            ,
            errorElement: <ErrorBoundary />
        },
        {
            path: "*",
            element: <Navigate to="/" />
        }
    ])
    return (
        <RouterProvider router={router} />
    )
}

export default Routes